import React from 'react'
import { useParams } from 'react-router-dom'

import { FeatureBottom } from './FeatureBottom'

const UpTheLadder = props => {
  const params = useParams()

  return (
    <div id="utl-content-section">
      <div className="container">
        <div className="row">
          <h2 className="col-sm-5 page-title">Career Exploration for Younger Learners</h2>
          <div className="col-sm-7">
            <img
              src="/images/common/earlyexploration/other/interests.svg"
              className="img-responsive"
            />
          </div>
        </div>
      </div>
      <div className="title-block-bar" style={{ backgroundColor: '#D7282F' }}>
        <div className="container">
          <div className="row">
            <div className="col-sm-6">
              <img
                src="/images/www/new/utl/utl_logo_nooutline-01.svg"
                style={{ maxWidth: '70%', margin: 'auto' }}
                className="img-responsive"
              />
            </div>
            <div className="col-sm-6" style={{ paddingTop: '24px', color: 'white' }}>
              <p style={{ fontWeight: 'bold', fontSize: '1.1rem' }}>
                <b>Up the Ladder</b> is an easy to navigate career education platform that
                is full of fun for younger learners.
              </p>
              <p style={{ fontSize: '1.1rem' }}>
                With engaging, colorful graphical design, and innovative text-to-speech
                capabilities, <b>Up the Ladder</b> is the perfect way to introduce career
                exploration to your upper elementary and middle school students.
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="container utl-features">
        <div className="row" style={{ paddingTop: '40px' }}>
          <div className="utl-feature-col">
            <div className="img-wrap">
              <img
                className="img-responsive"
                src="/images/www/new/utl/UTL-Gameboard@2x.png"
              />
            </div>
            <p>Familiar Gameboard Style Presentation</p>
          </div>
          <div className="utl-feature-col">
            <div className="img-wrap">
              <img className="img-responsive" src="/images/www/new/utl/UTL-Badges.svg" />
            </div>
            <p>Badges and Levels to Track Progress</p>
          </div>
          <div className="utl-feature-col">
            <div className="img-wrap">
              <img className="img-responsive" src="/images/www/new/utl/UTL-Avatar.svg" />
            </div>
            <p>Personalized Avatar and Backpack</p>
          </div>
          <br className="visible-xs" style={{ clear: 'both' }} />
          <div className="utl-feature-col">
            <div className="img-wrap">
              <img
                className="img-responsive"
                src="/images/www/new/utl/UTL-Visual@2x.png"
              />
            </div>
            <p>Highly Visual with Simplified Language</p>
          </div>
          <div className="utl-feature-col">
            <div className="img-wrap">
              <img className="img-responsive" src="/images/www/new/utl/UTL-Reader.svg" />
            </div>
            <p>Integrated Text-to-Speech to assist readers of all levels</p>
          </div>
          <div className="col-xs-10 col-xs-offset-1">
            <img src="/images/www/new/utl/UTL-Mockup@2x.png" className="img-responsive" />
          </div>
        </div>
      </div>
      <div className="home-section home-section-utl where-to-start">
        <div className="title-wrap-content-utl">
          <div className="container">
            <h2 className="utl-style">Now You Know Where to Start</h2>
          </div>
        </div>
        <div className="main-content-utl">
          <div className="container">
            <p>
              Beginning career education in elementary and middle school encourages
              students to translate their interests into high school choices and potential
              careers. <b>Up the Ladder</b> is fun, informative, inspiring and incredibly
              easy to use.
            </p>

            <br style={{ clear: 'left' }} />
          </div>
        </div>
      </div>

      <div className="home-section">
        <div className="container">
          <img
            src="/images/www/new/utl/utl-badge-guys.svg"
            style={{ maxWidth: '40%' }}
            className="pull-right hidden-xs"
          />
          <h2 className="utl-style">Badge Up!</h2>
          <p style={{ fontSize: '1.2rem' }}>
            Students earn badges on their way through each phase of their career and job
            explorations, making the journey fun for them, and easy for you to track their
            progress.
          </p>
        </div>
      </div>

      <div className="home-section see-it">
        <div className="container">
          <h2 className="utl-style">If They Can See It, They Can Be It</h2>
          <p style={{ fontSize: '1.2rem' }}>
            Career planning begins with career dreaming. The career wheel at the center of{' '}
            <b>Up The Ladder</b> allows students to try their luck at discovering and
            selecting inspiring jobs. With each potential job choice, students can easily
            find out what it takes to land a career, how much it might pay, what they
            should do to make it happen.
          </p>
        </div>
      </div>

      <div className="home-section">
        <div className="container">
          <img
            src="/images/www/new/utl/nice_simple.svg"
            style={{ maxWidth: '40%', marginLeft: '25px' }}
            className="pull-right hidden-xs"
          />
          <h2 className="utl-style">Nice & Simple</h2>
          <p style={{ fontSize: '1.2rem' }}>
            You can be ready to use <b>Up The Ladder</b> in your classrooms and
            after-school programs with your current internet connections and computers.
          </p>
        </div>
      </div>
      <FeatureBottom state={params.state} />
    </div>
  )
}

export default UpTheLadder
